import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Tabs, List, Divider } from 'antd'

const { TabPane } = Tabs

class EnglishCourseDetailsModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        course: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        item: {}
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { OpenCourseIdKey, OpenCourseKey, CourseCode, CourseTwName, SelectedType, CourseType, CourseCredit,
            OpenNum, UsualGradesPct, MidtermExamGradesPct, FinalExamGradesPct, TeacherId, TeacherName, TeachClassroom, TeachTimeDescription, OpenCourseCollege, OpenCourseDivision, OpenCourseEducationalSystem, OpenCourseDepartment, OpenClassroomName,
            AcademicYear, AcademicSemester, StartYearMonth, CompleteYearMonth } = this.props.course

        return (
            <>
                <List>
                    <List.Item>
                        <Divider orientation="left" style={{ borderColor: '#7cb305' }} dashed><i className="fas fa-align-justify"></i>{' '}課程資料{' '}</Divider>
                        學年/學期： {AcademicYear + '/' + AcademicSemester} <br />
                        開課流水號： {OpenCourseIdKey} <br />
                        開課序號： {OpenCourseKey} <br />
                        科目代碼： {CourseCode} <br />
                        課程名稱： {CourseTwName} <br />
                        課程起訖： {StartYearMonth + '/' + CompleteYearMonth} <br />
                        選課人數： {OpenNum}
                    </List.Item>
                </List>
                <Tabs defaultActiveKey="1" type="line" className="tabsStyle">
                    <TabPane tab={<span><i className="fas fa-align-left"></i>{' '}開課資訊</span>} key="1" >
                        <List>
                            <List.Item>
                                開課學院： {OpenCourseCollege} <br />
                                開課部別： {OpenCourseDivision} <br />
                                開課學制： {OpenCourseEducationalSystem}<br />
                                開課系所： {OpenCourseDepartment}<br />
                                開課班級： {OpenClassroomName}<br />
                            </List.Item>
                        </List>
                    </TabPane>
                    <TabPane tab={<span><i className="fas fa-align-center"></i>{' '}授課資訊</span>} key="2" >
                        <List>
                            <List.Item>
                                <Divider orientation="left"><i className="fas fa-address-book"></i>{' '}授課老師</Divider>
                                授課老師職號： {TeacherId} <br />
                                授課老師姓名： {TeacherName} <br />
                                <Divider orientation="left"><i className="fas fa-chalkboard-teacher"></i>{' '}授課時間地點</Divider>
                                時間： {TeachTimeDescription} <br />
                                地點： {TeachClassroom} <br />
                            </List.Item>
                        </List>
                    </TabPane>
                    <TabPane tab={<span><i className="fas fa-align-right"></i>{' '}分數計算</span>} key="3">
                        課程型態: {SelectedType + ' / ' + CourseType + '/ ' + CourseCredit + '學分'} <br />
                        平常成績： {UsualGradesPct + ' % '} <br />
                        期中成績： {MidtermExamGradesPct + ' % '} <br />
                        期末成績： {FinalExamGradesPct + ' % '} <br />
                    </TabPane>
                </Tabs >

            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(EnglishCourseDetailsModal)